let timetableConfig = {
  header: [
    { prop: "Время", lg: 2 },
    { prop: "Клиент", lg: 7 },
    { prop: "Телефон", lg: 4 },
    { prop: "Статус заявки", lg: 6 },
    { prop: "Номер заявки", lg: 5 }
  ],
  getBody: data => ({
    time: { type: "text", prop: data.getTime(), lg: 2 },
    client: { type: "text", prop: data.client.fio, lg: 7 },
    phone: { type: "text", prop: data.client.phone, lg: 4 },
    status: { type: "status", prop: data.getStatusConfig(), lg: 6 },
    num: { type: "text", prop: data.id, lg: 2 },
    link: { type: "link", prop: data.id, lg: 3 }
  })
};
export default timetableConfig;
